import script from "./QuitModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuitModal.vue?vue&type=script&setup=true&lang=ts"

import "./QuitModal.vue?vue&type=style&index=0&id=d3462842&lang=scss"

const __exports__ = script;

export default __exports__